import { EDealType, EOfferType, IJsonQuery } from './types';
import { dealTypeFromJsonQuery, offerTypeFromJsonQuery } from '../category';

export function isAvailable(dealType: EDealType, offerType: EOfferType): (jsonQuery: IJsonQuery) => boolean {
  return jsonQuery => {
    const nextDealType = dealTypeFromJsonQuery(jsonQuery);
    const nextOfferType = offerTypeFromJsonQuery(jsonQuery);

    return (dealType & nextDealType) !== 0 && (offerType & nextOfferType) !== 0;
  };
}
